/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S5_P3Inputs */

const en_guide_what_is_json_s5_p3 = /** @type {(inputs: Guide_What_Is_Json_S5_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you need to convert JSON to other formats for different tools or team members, PureJSON offers converters for <a href="/json-to-yaml">YAML</a>, <a href="/json-to-csv">CSV</a>, <a href="/json-to-xml">XML</a>, and <a href="/json-to-typescript">TypeScript interfaces</a>: all running locally in your browser with no data sent to any server.`)
};

const ko_guide_what_is_json_s5_p3 = /** @type {(inputs: Guide_What_Is_Json_S5_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 다른 포맷으로 변환해야 할 때, PureJSON은 <a href="/json-to-yaml">YAML</a>, <a href="/json-to-csv">CSV</a>, <a href="/json-to-xml">XML</a>, <a href="/json-to-typescript">TypeScript 인터페이스</a>로의 변환기를 제공합니다: 모두 브라우저에서 로컬로 실행되며 어떤 서버로도 데이터가 전송되지 않습니다.`)
};

const ja_guide_what_is_json_s5_p3 = /** @type {(inputs: Guide_What_Is_Json_S5_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONを他のフォーマットに変換する必要がある場合、PureJSONは<a href="/json-to-yaml">YAML</a>、<a href="/json-to-csv">CSV</a>、<a href="/json-to-xml">XML</a>、<a href="/json-to-typescript">TypeScriptインターフェース</a>への変換ツールを提供しています。すべてブラウザ内でローカルに実行され、データはサーバーに送信されません。`)
};

/**
* | output |
* | --- |
* | "If you need to convert JSON to other formats for different tools or team members, PureJSON offers converters for <a href=\"/json-to-yaml\">YAML</a>, <a href=\"/..." |
*
* @param {Guide_What_Is_Json_S5_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s5_p3 = /** @type {((inputs?: Guide_What_Is_Json_S5_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S5_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s5_p3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s5_p3(inputs)
	return ja_guide_what_is_json_s5_p3(inputs)
});